import axios from 'axios';
import store from '../reducers/store';

export default async function updateAnalytics(params, id) {
  const baseURL = store.getState().formState.baseURL;

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = {
    method: 'create',
    resource: 'analytics-event',
    payload: {
      src: 'self-signup',
      name: 'self-signup-flow-event',
      restaurantId: id,
      ...params,
    },
  };

  try {
    await axios.post(`${baseURL}/smart-restaurant/api`, body, config);
  } catch (e) {
    console.log('EVENT FAILED', e);
  }
}
